<template>
  <Row :gutter="20" class="padding-t-20 dashboard-content">
    <i-col :xs="24" :sm="10" :md="8">
      <ViewsCount :views="dashboardData.views"/>
      <UniqueViewsCount :views="dashboardData.unique_views" style="margin-top:20px"/>
      <DevicesCount v-if="dashboardData.devices" :counts="dashboardData.devices" style="margin-top:20px"/>
      <TopCountries v-if="dashboardData.countries" :counts="dashboardData.countries" style="margin-top:20px"/>
    </i-col>
    <i-col :xs="24" :sm="12" :md="16">
      <VisitsGraph :visits="dashboardData.visits" :uniqueVisits="dashboardData.unique_visits"/>
      <TopReferrers v-if="dashboardData.references" :counts="dashboardData.references" style="margin-top:20px"/>
      <Row :gutter="20">
        <i-col :xs="24" :sm="12">
          <TopPlatforms v-if="dashboardData.platforms" :counts="dashboardData.platforms" style="margin-top:20px"/>
        </i-col>
        <i-col :xs="24" :sm="12">
          <TopBrowsers v-if="dashboardData.browsers" :counts="dashboardData.browsers" style="margin-top:20px"/>
        </i-col>
      </Row>
    </i-col>
  </Row>
</template>

<script>
import ViewsCount from '@/components/analytics/ViewsCount'
import VisitsGraph from '@/components/analytics/VisitsGraph'
import UniqueViewsCount from '@/components/analytics/UniqueViewsCount'
import DevicesCount from '@/components/analytics/DevicesCount'
import TopCountries from '@/components/analytics/TopCountries'
import TopReferrers from '@/components/analytics/TopReferrers'
import TopPlatforms from '@/components/analytics/TopPlatforms'
import TopBrowsers from '@/components/analytics/TopBrowsers'

export default {
  components: {
    ViewsCount,
    VisitsGraph,
    UniqueViewsCount,
    DevicesCount,
    TopCountries,
    TopReferrers,
    TopPlatforms,
    TopBrowsers
  },

  props: {
    dashboardData: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="scss">
.dashboard-content {
  .weekly-visits {
    img {
      width: 40px !important;
    }
  }
}
</style>
